<template>
    <svg :width="size" :height="size" viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg" :style="{ fill: colour }">
        <path v-if="!waves"
            d="M24 14.29l-4.5-4.5-1 1-1.29-1.29 2-2-2.71-2.71-2 2-1.29-1.29 1-1L9.71 0h-.42l-2.5 2.5 4.71 4.71 1-1 1.29 1.29-2 2 2.71 2.71 2-2 1.29 1.29-1 1 4.71 4.71 2.5-2.5z" />
        <path v-else
            d="M1 9H0a15.018 15.018 0 0 0 15 15v-1A14.015 14.015 0 0 1 1 9zm4 0H4a11.007 11.007 0 0 0 11 11v-1A10.016 10.016 0 0 1 5 9zm4 0H8a7.008 7.008 0 0 0 7 7v-1a6.005 6.005 0 0 1-6-6zm15 5.29l-4.5-4.5-1 1-1.29-1.29 2-2-2.71-2.71-2 2-1.29-1.29 1-1L9.71 0h-.42l-2.5 2.5 4.71 4.71 1-1 1.29 1.29-2 2 2.71 2.71 2-2 1.29 1.29-1 1 4.71 4.71 2.5-2.5z" />
        <path fill="none" d="M0 0h24v24H0z" />
    </svg>
</template>

<script>
export default {
  name: 'SatelliteWaveIcon',
  props: {
    colour: {
      type: String,
      default: 'currentColor'
    },
    size: {
      type: [Number, String],
      default: '24'
    },
    waves: {
      type: Boolean,
      default: false
    }
  }
}
</script>